import localforage from 'localforage';

/* Project specific storage api */
/* eslint consistent-return: 0 */
export const loadState = cb => {
  try {
    localforage.getItem('state', (err, state) => {
      if (err) return cb(err);
      return cb(null, JSON.parse(state));
    });
  } catch (err) {
    return cb(null, {});
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localforage.setItem('state', serializedState);
  } catch (err) {
    // err while saving state
  }
};

export const removeState = () => {
  try {
    localforage.clear();
  } catch (err) {
    // err while saving state
  }
};
